import { useGoogleAuthStore } from "./googleAuth.store";

export const setGoogleAuthLoading = (v: boolean) => {
  useGoogleAuthStore.setState({ loading: v });
};
